import { render } from "./TwoWidgetsComponent.vue?vue&type=template&id=4332a65c&scoped=true"
import script from "./TwoWidgetsComponent.vue?vue&type=script&lang=js"
export * from "./TwoWidgetsComponent.vue?vue&type=script&lang=js"

import "./TwoWidgetsComponent.vue?vue&type=style&index=0&id=4332a65c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4332a65c"]])

export default __exports__